import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import type { JourneyAssignmentRow } from "@colab/shared";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// POST /api/portal/journeys/:assignmentId/complete — partner-side explicit
// journey-complete gesture. Idempotent. Invalidates list + detail caches
// so the "Completed" tab refreshes immediately.

type Input = { assignmentId: string };

export function useCompleteJourney() {
  const queryClient = useQueryClient();
  return useMutation<JourneyAssignmentRow, ApiClientError, Input>({
    mutationFn: ({ assignmentId }) =>
      apiFetch<JourneyAssignmentRow>(
        `/portal/journeys/${assignmentId}/complete`,
        { method: "POST" },
      ),
    onSuccess: (_data, { assignmentId }) => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.portal.journeys.list(),
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.portal.journeys.detail(assignmentId),
      });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to mark journey complete");
    },
  });
}
